import React from "react";

function MultiRecommendationInfo({ multi_recommendation_props }) {
    return (
        <>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Recommendation Summaary Properties</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Name</h4>
                    <h3>{multi_recommendation_props?.heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Size</h4>
                    <h3>{multi_recommendation_props?.heading?.font_size ? `${multi_recommendation_props?.heading?.font_size} pt` : ""}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.heading?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.heading?.font_color
                                    ? `#${multi_recommendation_props?.heading?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Name</h4>
                    <h3>{multi_recommendation_props?.body?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Size</h4>
                    <h3>{multi_recommendation_props?.body?.font_size ? `${multi_recommendation_props?.body?.font_size} pt` : ""}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Body Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.body?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.body?.font_color
                                    ? `#${multi_recommendation_props?.body?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Caption Font Name</h4>
                    <h3>{multi_recommendation_props?.caption?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Caption Font Size</h4>
                    <h3>{`${multi_recommendation_props?.caption?.font_size || "-"} pt`}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Caption Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.caption?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.caption?.font_color
                                    ? `#${multi_recommendation_props?.caption?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Notes Font Name</h4>
                    <h3>{multi_recommendation_props?.notes?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Notes Font Size</h4>
                    <h3>{`${multi_recommendation_props?.notes?.font_size || "-"} pt`}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Notes Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.notes?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.notes?.font_color
                                    ? `#${multi_recommendation_props?.notes?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            {multi_recommendation_props?.sub_total?.is_sub_total && (
                <>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Font Name</h4>
                            <h3>{(multi_recommendation_props?.sub_total?.font_id && multi_recommendation_props?.sub_total?.font_family) || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Font Size</h4>
                            <h3>{multi_recommendation_props?.sub_total?.font_size || "-"}</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Font Color</h4>
                            <h3>
                                {multi_recommendation_props?.sub_total?.font_colour || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: multi_recommendation_props?.sub_total?.font_colour
                                            ? `#${multi_recommendation_props?.sub_total?.font_colour}`
                                            : ""
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Background Color</h4>
                            <h3>
                                {multi_recommendation_props?.sub_total?.background_colour || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: multi_recommendation_props?.sub_total?.background_colour
                                            ? `#${multi_recommendation_props?.sub_total?.background_colour}`
                                            : ""
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Border Color</h4>
                            <h3>
                                {multi_recommendation_props?.sub_total?.background_colour || "-"}

                                <span
                                    className="color"
                                    style={{
                                        backgroundColor: multi_recommendation_props?.sub_total?.border_colour
                                            ? `#${multi_recommendation_props?.sub_total?.border_colour}`
                                            : ""
                                    }}
                                ></span>
                            </h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Border </h4>
                            <div className={`input-ft-size`}>
                                <span className="check-align">
                                    <input disabled type="checkbox" defaultChecked={multi_recommendation_props?.sub_total?.border?.left}></input>
                                    <label>left</label>
                                </span>
                                <span className="check-align">
                                    <input disabled type="checkbox" defaultChecked={multi_recommendation_props?.sub_total?.border?.right}></input>
                                    <label>right</label>
                                </span>
                                <span className="check-align">
                                    <input disabled type="checkbox" defaultChecked={multi_recommendation_props?.sub_total?.border?.top}></input>
                                    <label>top</label>
                                </span>
                                <span className="check-align">
                                    <input disabled type="checkbox" defaultChecked={multi_recommendation_props?.sub_total?.border?.bottom}></input>
                                    <label>bottom</label>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Cell Margin Top</h4>
                            <h3>{multi_recommendation_props?.sub_total?.cell_margin?.top || "-"} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Cell Margin Left</h4>
                            <h3>{multi_recommendation_props?.sub_total?.cell_margin?.left || "-"} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Cell Margin Right</h4>
                            <h3>{multi_recommendation_props?.sub_total?.cell_margin?.right || "-"} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>Sub Total Cell Margin Bottom</h4>
                            <h3>{multi_recommendation_props?.sub_total?.cell_margin?.bottom || "-"} inch</h3>
                        </div>
                    </div>
                    <div className="col-md-6 basic-box"></div>
                </>
            )}
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Seperator Properties</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Border Size</h4>
                    <h3>{multi_recommendation_props?.seperator_line?.size || "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Border Color</h4>
                    <h3>
                        {multi_recommendation_props?.seperator_line?.color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.seperator_line?.color
                                    ? `#${multi_recommendation_props?.seperator_line?.color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Border Style</h4>
                    <h3>{multi_recommendation_props?.seperator_line?.style || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Space After</h4>
                    <h3>{multi_recommendation_props?.seperator_line?.space_after || "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Space Before</h4>
                    <h3>{multi_recommendation_props?.seperator_line?.space_before || "-"} Pt</h3>
                </div>
            </div>
            <div className="col-md-9 basic-box"></div>

            <>
                <div className="col-md-12 basic-box main-heading mt-2">
                    <h3>Filtered By Properties</h3>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Custom Heading Label</h4>
                        <h3>
                            {(multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.label &&
                                multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.label) ||
                                "-"}
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Custom Heading Font Name</h4>
                        <h3>
                            {(multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_id &&
                                multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_family) ||
                                "-"}
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Custom Heading Font Size</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_size || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Custom Heading Font Color</h4>
                        <h3>
                            {multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_colour || "-"}

                            <span
                                className="color"
                                style={{
                                    backgroundColor: multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_colour
                                        ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_colour}`
                                        : ""
                                }}
                            ></span>
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Custom Heading Bold</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_custom_heading?.font_bold ? "Yes" : "No" || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box"></div>
                <div className="col-md-3 basic-box"></div>
                <div className="col-md-3 basic-box"></div>

                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Label Font Name</h4>
                        <h3>
                            {(multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_id &&
                                multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_family) ||
                                "-"}
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Label Font Size</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_size || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Label Bold</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_bold ? "Yes" : "No" || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Label Font Color</h4>
                        <h3>
                            {multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_colour || "-"}

                            <span
                                className="color"
                                style={{
                                    backgroundColor: multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_colour
                                        ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.labels?.font_colour}`
                                        : ""
                                }}
                            ></span>
                        </h3>
                    </div>
                </div>

                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Values Font Name</h4>
                        <h3>
                            {(multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_id &&
                                multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_family) ||
                                "-"}
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Values Font Size</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_size || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Values Bold</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_bold ? "Yes" : "No" || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Values Font Color</h4>
                        <h3>
                            {multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_colour || "-"}

                            <span
                                className="color"
                                style={{
                                    backgroundColor: multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_colour
                                        ? `#${multi_recommendation_props?.filter_by_custom_props?.filter_by_props?.values?.font_colour}`
                                        : ""
                                }}
                            ></span>
                        </h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Alignment</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.alignment || "-"}</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Margin Top</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.cell_margin?.top || "-"} inch</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Margin Left</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.cell_margin?.left || "-"} inch</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Margin Right</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.cell_margin?.right || "-"} inch</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Margin Bottom</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.cell_margin?.bottom || "-"} inch</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Space After</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.space_after || "-"} Pt</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box">
                    <div className="codeOtr">
                        <h4>Filtered By Space Before</h4>
                        <h3>{multi_recommendation_props?.filter_by_custom_props?.space_before || "-"} Pt</h3>
                    </div>
                </div>
                <div className="col-md-3 basic-box"></div>
            </>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Memo Properties</h3>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Field Property Status </h4>
                    <h3>{multi_recommendation_props?.memo_properties?.memo_props_active ? "Active" : "Inactive" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Name</h4>
                    <h3>{multi_recommendation_props?.memo_properties?.heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Size</h4>
                    <h3>
                        {multi_recommendation_props?.memo_properties?.heading?.font_size
                            ? `${multi_recommendation_props?.memo_properties?.heading?.font_size} pt`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.memo_properties?.heading?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.memo_properties?.heading?.font_color
                                    ? `#${multi_recommendation_props?.memo_properties?.heading?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Heading Font Bold </h4>
                    <h3>{multi_recommendation_props?.memo_properties?.heading?.font_bold ? "Yes" : "No" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Name</h4>
                    <h3>{multi_recommendation_props?.memo_properties?.body?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Size</h4>
                    <h3>
                        {multi_recommendation_props?.memo_properties?.body?.font_size
                            ? `${multi_recommendation_props?.memo_properties?.body?.font_size} pt`
                            : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Color</h4>
                    <h3>
                        {multi_recommendation_props?.memo_properties?.body?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: multi_recommendation_props?.memo_properties?.body?.font_color
                                    ? `#${multi_recommendation_props?.memo_properties?.body?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Font Bold </h4>
                    <h3>{multi_recommendation_props?.memo_properties?.body?.font_bold ? "Yes" : "No" || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Memo Body Alignment</h4>
                    <h3>{multi_recommendation_props?.memo_properties?.body?.alignment}</h3>
                </div>
            </div>
        </>
    );
}

export default MultiRecommendationInfo;
